import React, { useEffect, useState } from "react";
// import image1 from "../../images/aboutslush.png";
import image2 from "../../images/WW-Hero-1.jpg";
// import captcha from '../../images/captcha.png';
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useForm } from "react-hook-form";
import Axios from "axios";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { Helmet } from "react-helmet";

// import { TimePicker } from '@mui/x-date-pickers/TimePicker';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
// import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
// import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';

import styles from "./index.module.css";
import { format } from "date-fns";
import { Alert, IconButton } from "@mui/material";
import { getIdFromTrigger } from "materialize-css";

let url = window.location.href;
let arr = url.split("/");
let arr2 = arr[2].split(":");
const URL = arr[0] + "//" + arr2[0] + "/cfc/api/";

const form = {
	first_name: "",
	last_name: "",
	email: "",
	message: "",
	file: "",
	date_attended: null,
	to_date: null,
};

const listOfStates = [
	"Alabama",
	"Alaska",
	"Arizona",
	"Arkansas",
	"California",
	"Colorado",
	"Connecticut",
	"Delaware",
	"District of Columbia",
	"Florida",
	"Georgia",
	"Guam",
	"Hawaii",
	"Idaho",
	"Illinois",
	"Indiana",
	"Iowa",
	"Kansas",
	"Kentucky",
	"Louisiana",
	"Maine",
	"Maryland",
	"Massachusetts",
	"Michigan",
	"Minnesota",
	"Mississippi",
	"Missouri",
	"Montana",
	"Nebraska",
	"Nevada",
	"New Hampshire",
	"New Jersey",
	"New Mexico",
	"New York",
	"North Carolina",
	"North Dakota",
	"Northern Marianas Islands",
	"Ohio",
	"Oklahoma",
	"Oregon",
	"Pennsylvania",
	"Puerto Rico",
	"Rhode Island",
	"South Carolina",
	"South Dakota",
	"Tennessee",
	"Texas",
	"Utah",
	"Vermont",
	"Virginia",
	"Virgin Islands",
	"Washington",
	"West Virginia",
	"Wisconsin",
	"Wyoming",
];

const RequestinformationPage = () => {
	const { register, handleSubmit, errors, setValue, trigger, watch } =
		useForm({
			defaultValues: form,
			shouldUnregister: false,
		});
	const [message, setMessage] = useState(null);
	const [checked, setChecked] = useState(true);

	const handleChecked = () => setChecked(!checked);

	const date_attended = watch("date_attended");
	const to_date = watch("to_date");

	const onSubmit = (v, e) => {
		const data = { ...form, ...v };

		Axios({
			method: "POST",
			url: `${URL}webmail.cfc?method=requestInfo`,
			headers: {
				"Content-Type": "application/json",
			},
			data,
		})
			.then((res) => res.status === 200 && res.data)
			.then((data) => {
				if (data.success) {
					e.target.reset();
					window.scrollTo({
						top: 0,
						left: 0,
						behavior: "smooth",
					});
					// M.toast({ html: 'Thanks, we will get back to you soon!' });
					setMessage("Thanks, we will get back to you soon!");
				}
			})
			.catch((e) => console.log(e));
	};
	// console.log(errors);

	useEffect(() => {
		let timer1 = setTimeout(() => setMessage(""), 8 * 1000);

		// this will clear Timeout
		// when component unmount like in willComponentUnmount
		// and show will not change to true
		return () => {
			clearTimeout(timer1);
		};
	}, [message]);

	console.log({ errors });

	return (
		<div className={styles.RequestinformationPage}>
			<Helmet>
				<title>Wetwillies | Request Information</title>
			</Helmet>
			<div className={styles.figureContainer}>
				<figure>
					<img src={image2} alt="" />
				</figure>
			</div>
			<div className={styles.header}>
				<h1>REQUEST INFO</h1>
			</div>
			{/* <button onClick={() => setMessage('sdasdasd')}>test</button> */}
			<div className={styles.articleContainer}>
				<Container maxWidth="md" sx={{ pt: { xs: 2, sm: 5 }, py: 5 }}>
					<article>
						<section className={styles.section2}>
							{message && message.length > 0 && (
								<Alert
									action={
										<IconButton
											aria-label="close"
											color="inherit"
											size="medium"
											onClick={() => setMessage("")}
										>
											<IoIosCloseCircleOutline />
										</IconButton>
									}
									sx={{ mb: 2 }}
								>
									{message}
								</Alert>
							)}
							<p>
								Thank you for your interest in Wet Willie's! By
								completing this information request form, we can
								begin the process of qualifying you. We will
								contact you directly, typically within two
								weeks, to discuss furthering the process and
								putting you on the road to support global
								cooling.
							</p>
							<br />
							<p className={styles.miniWarn}>
								Please read our Terms and Conditions before
								submitting.
							</p>
							<br />
							<div className={styles.formSharpe}>
								<div className={styles.formHeader}>
									Franchise Information Request Form
								</div>
								<div className={styles.form1}>
									<Grid
										container
										item
										xs={12}
										lg={12}
										sx={{ mx: "auto" }}
									>
										<form
											width="100%"
											component="form"
											autoComplete="off"
											onSubmit={handleSubmit(onSubmit)}
										>
											<Box p={3}>
												<Grid container spacing={3}>
													<Grid item xs={12}>
														<span>
															All fields are
															required
														</span>
													</Grid>
													<Grid item xs={12} md={6}>
														<TextField
															id="first_name"
															name="first_name"
															variant="filled"
															label="First Name"
															fullWidth
															inputRef={register({
																required:
																	"First Name is required",
															})}
														/>
														{errors &&
															errors.first_name &&
															errors.first_name
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.first_name
																			.message
																	}
																</span>
															)}
													</Grid>

													<Grid item xs={12} md={6}>
														<TextField
															id="last_name"
															name="last_name"
															variant="filled"
															label="Last Name"
															fullWidth
															inputRef={register({
																required:
																	"Last Name is required",
															})}
														/>
														{errors &&
															errors.last_name &&
															errors.last_name
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.last_name
																			.message
																	}
																</span>
															)}
													</Grid>

													<Grid item xs={12} md={6}>
														<TextField
															id="home_address"
															name="home_address"
															variant="filled"
															label="Home Address"
															fullWidth
															inputRef={register({
																required:
																	"Home Address is required",
															})}
														/>
														{errors &&
															errors.home_address &&
															errors.home_address
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.home_address
																			.message
																	}
																</span>
															)}
													</Grid>

													<Grid item xs={12} md={6}>
														<TextField
															id="city"
															name="city"
															variant="filled"
															label="City"
															fullWidth
															inputRef={register({
																required:
																	"City is required",
															})}
														/>
														{errors &&
															errors.city &&
															errors.city
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.city
																			.message
																	}
																</span>
															)}
													</Grid>

													<Grid
														item
														xs={12}
														md={6}
														style={{
															position:
																"relative",
														}}
													>
														<select
															variant="filled"
															fullWidth
															defaultValue=""
															name="state"
															ref={register({
																required:
																	"State is required",
															})}
															style={{
																width: "100%",
																height: "56px",
																border: "0",
																borderBottom:
																	"1px solid #919191",
																borderRadius:
																	"4px 4px 0 0",
																padding:
																	"25px 10px 5px",
																fontSize:
																	"15px",
																fontWeight:
																	"500",
															}}
														>
															<option
																value=""
																disabled
															>
																Choose your
																State
															</option>
															{listOfStates.map(
																(name) => (
																	<option
																		key={
																			name
																		}
																		value={
																			name
																		}
																	>
																		{name}
																	</option>
																)
															)}
														</select>
														<label
															style={{
																position:
																	"absolute",
																top: "31px",
																left: "39px",
																fontSize:
																	"13px",
																color: "#606060",
															}}
														>
															State
														</label>
														{errors &&
															errors.state &&
															errors.state
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.state
																			.message
																	}
																</span>
															)}
													</Grid>

													<Grid item xs={12} md={6}>
														<TextField
															id="zip"
															name="zip"
															variant="filled"
															label="Zip"
															fullWidth
															inputRef={register({
																required:
																	"Zip is required",
															})}
														/>
														{errors &&
															errors.zip &&
															errors.zip
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.zip
																			.message
																	}
																</span>
															)}
													</Grid>

													<Grid item xs={12} md={6}>
														<TextField
															id="home_phone"
															name="home_phone"
															variant="filled"
															label="Home Phone"
															fullWidth
															inputRef={register({
																required:
																	"Home Phone is required",
															})}
														/>
														{errors &&
															errors.home_phone &&
															errors.home_phone
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.home_phone
																			.message
																	}
																</span>
															)}
													</Grid>

													<Grid item xs={12} md={6}>
														<TextField
															id="cell_phone"
															name="cell_phone"
															variant="filled"
															label="Cell Phone"
															fullWidth
															inputRef={register({
																required:
																	"Cell Phone is required",
															})}
														/>
														{errors &&
															errors.cell_phone &&
															errors.cell_phone
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.cell_phone
																			.message
																	}
																</span>
															)}
													</Grid>

													<Grid item xs={12} md={6}>
														<TextField
															id="email"
															name="email"
															variant="filled"
															label="Email Address"
															type="email"
															fullWidth
															inputRef={register({
																required:
																	"Email Address is required",
															})}
														/>
														{errors &&
															errors.email &&
															errors.email
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.email
																			.message
																	}
																</span>
															)}
													</Grid>

													{ /* 
													<Grid item xs={12} md={6}>
														<TextField
															id="time_place_to_call"
															name="time_place_to_call"
															variant="filled"
															label="Best Time / Place To Call"
															fullWidth
															inputRef={register({
																required:
																	"Best Time / Place To Call is required",
															})}
														/>
														{errors &&
															errors.time_place_to_call &&
															errors
																.time_place_to_call
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.time_place_to_call
																			.message
																	}
																</span>
															)}
													</Grid>
													*/}

													<Grid item xs={12}>
														<p>
															Educational
															Background :{" "}
														</p>
														{errors &&
															errors.educational_background &&
															errors
																.educational_background
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.educational_background
																			.message
																	}
																</span>
															)}
													</Grid>
													<Grid
														item
														xs={6}
														md={3}
														alignItems="center"
													>
														<FormControlLabel
															id="educational_background"
															name="educational_background"
															control={
																<Checkbox />
															}
															sx={{
																"& .MuiSvgIcon-root":
																	{
																		fontSize: 28,
																	},
															}}
															label="High School"
															value="High School"
															inputRef={register({
																required:
																	"Please check your educational background",
															})}
														/>
													</Grid>

													<Grid
														item
														xs={6}
														md={3}
														alignItems="center"
													>
														<FormControlLabel
															id="educational_background"
															name="educational_background"
															control={
																<Checkbox />
															}
															label="Some College"
															value="Some College"
															sx={{
																"& .MuiSvgIcon-root":
																	{
																		fontSize: 28,
																	},
															}}
															inputRef={register({
																required:
																	"Please check your educational background",
															})}
														/>
													</Grid>

													<Grid
														item
														xs={6}
														md={3}
														alignItems="center"
													>
														<FormControlLabel
															id="educational_background"
															name="educational_background"
															control={
																<Checkbox />
															}
															label="College Degree"
															value="College Degree"
															sx={{
																"& .MuiSvgIcon-root":
																	{
																		fontSize: 28,
																	},
															}}
															inputRef={register({
																required:
																	"Please check your educational background",
															})}
														/>
													</Grid>

													<Grid
														item
														xs={6}
														md={3}
														alignItems="center"
													>
														<FormControlLabel
															id="educational_background"
															name="educational_background"
															control={
																<Checkbox />
															}
															label="Graduate School"
															value="Graduate School"
															sx={{
																"& .MuiSvgIcon-root":
																	{
																		fontSize: 28,
																	},
															}}
															inputRef={register({
																required:
																	"Please check your educational background",
															})}
														/>
													</Grid>

													<Grid item xs={12}>
														<TextField
															name="which_colleges"
															inputRef={register}
															variant="filled"
															label="Which College(s)"
															fullWidth
														/>
													</Grid>
													<Grid item xs={12} md={6}>
														<input
															name="date_attended"
															ref={register({
																required:
																	"Date attended is required",
															})}
															type="hidden"
														/>
														<LocalizationProvider
															dateAdapter={
																AdapterDateFns
															}
														>
															<DatePicker
																label="Date Attended"
																value={
																	date_attended
																}
																onChange={(
																	newDateAttended
																) => {
																	try {
																		setValue(
																			"date_attended",
																			format(
																				newDateAttended,
																				"P"
																			)
																		);
																	} catch (e) {}
																	if (
																		errors.date_attended
																	)
																		trigger();
																}}
																// inputRef={register({
																//   required: 'Date attended is required',
																// })}
																readOnly={false}
																renderInput={(
																	params
																) => {
																	params.error =
																		errors.date_attended &&
																		errors
																			.date_attended
																			.message;
																	return (
																		<TextField
																			fullWidth
																			variant="filled"
																			name="date_attended"
																			{...params}
																		/>
																	);
																}}
															/>
														</LocalizationProvider>
														{errors &&
															errors.date_attended &&
															errors.date_attended
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.date_attended
																			.message
																	}
																</span>
															)}
													</Grid>

													<Grid item xs={12} md={6}>
														<input
															name="to_date"
															ref={register({
																required:
																	"To date is required",
															})}
															type="hidden"
														/>
														<LocalizationProvider
															dateAdapter={
																AdapterDateFns
															}
														>
															<DatePicker
																label="To Date"
																emptyLabel="To Date"
																placeholder="To Date"
																value={to_date}
																onChange={(
																	newToDate
																) => {
																	try {
																		setValue(
																			"to_date",
																			format(
																				newToDate,
																				"P"
																			)
																		);
																	} catch (e) {}
																	if (
																		errors.to_date &&
																		errors
																			.to_date
																			.message
																	)
																		trigger();
																}}
																// inputRef={register({
																//   required: 'To date is required',
																// })}
																renderInput={(
																	params
																) => {
																	params.error =
																		errors.to_date &&
																		errors
																			.to_date
																			.message;
																	return (
																		<TextField
																			fullWidth
																			variant="filled"
																			name="to_date"
																			{...params}
																		/>
																	);
																}}
															/>
														</LocalizationProvider>
														{errors &&
															errors.to_date &&
															errors.to_date
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.to_date
																			.message
																	}
																</span>
															)}
													</Grid>
													<Grid item xs={12}>
														<TextField
															id="current_occupation"
															name="current_occupation"
															variant="filled"
															label="Current Occupation"
															fullWidth
															inputRef={register({
																required:
																	"Current Occupation is required, please type umemployment if currently no work",
															})}
														/>
														{errors &&
															errors.current_occupation &&
															errors
																.current_occupation
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.current_occupation
																			.message
																	}
																</span>
															)}
													</Grid>
													<Grid item xs={12}>
														<TextField
															id="city_of_interest_ww"
															name="city_of_interest_ww"
															variant="filled"
															label="List your city or cities of interest for a Wet Willie's franchise"
															multiline
															fullWidth
															rows={3}
															inputRef={register({
																required:
																	"Please answer the question above",
															})}
														/>
														{errors &&
															errors.city_of_interest_ww &&
															errors
																.city_of_interest_ww
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.city_of_interest_ww
																			.message
																	}
																</span>
															)}
													</Grid>
													<Grid item xs={12}>
														<TextField
															id="hear_about_ww"
															name="hear_about_ww"
															variant="filled"
															label="How did you hear about Wet Willie's?"
															fullWidth
															inputRef={register({
																required:
																	"Please answer the question above",
															})}
														/>
														{errors &&
															errors.hear_about_ww &&
															errors.hear_about_ww
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.hear_about_ww
																			.message
																	}
																</span>
															)}
													</Grid>
													<Grid
														item
														xs={12}
														md={6}
														style={{
															position:
																"relative",
														}}
													>
														<select
															variant="filled"
															fullWidth
															defaultValue=""
															name="when_open_ww"
															ref={register({
																required:
																	"Please answer the question above",
															})}
															style={{
																width: "100%",
																height: "56px",
																border: "0",
																borderBottom:
																	"1px solid #919191",
																borderRadius:
																	"4px 4px 0 0",
																padding:
																	"25px 10px 5px",
																fontSize:
																	"15px",
																fontWeight:
																	"500",
															}}
														>
															<option
																value=""
																disabled
															></option>
															<option value="1 to 3 months">
																1 to 3 months
															</option>
															<option value="3 to 6 months">
																3 to 6 months
															</option>
															<option value="6 months to 1 year">
																6 months to 1
																year
															</option>
															<option value="More than 1 year">
																More than 1 year
															</option>
														</select>
														<label
															style={{
																position:
																	"absolute",
																top: "31px",
																left: "39px",
																fontSize:
																	"13px",
																color: "#606060",
															}}
														>
															When would you want
															to open your Wet
															Willie's?
														</label>
														{errors &&
															errors.when_open_ww &&
															errors.when_open_ww
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.when_open_ww
																			.message
																	}
																</span>
															)}
														{/* <FormControl
														variant="filled"
														fullWidth
														sx={{ minWidth: 120 }}
													>
														<InputLabel id="when_open_ww_label">
															When would you want to open your Wet Willie's?
														</InputLabel>
														<Select
															labelId="when_open_ww_label"
															id="when_open_ww"
															name="when_open_ww"
															value={age}
															onChange={handleEventChange}
															fullWidth
															ref={register({
																required: 'Please answer the question above',
															})}
														>
															<MenuItem value="">
																<em>None</em>
															</MenuItem>
															<MenuItem value={10}>1 to 3 months</MenuItem>
															<MenuItem value={20}>3 to 6 months</MenuItem>
															<MenuItem value={30}>6 months to 1 year</MenuItem>
															<MenuItem value={30}>More than 1 year</MenuItem>
														</Select>
													</FormControl>
													{errors &&
														errors.when_open_ww &&
														errors.when_open_ww.message && (
															<span className={styles.redText}>
																{errors.when_open_ww.message}
															</span>
														)} */}
													</Grid>

													<Grid item xs={12} md={6}>
														<TextField
															id="amounnt_capital"
															name="amounnt_capital"
															variant="filled"
															label="Amount of capital available for business"
															fullWidth
															inputRef={register({
																required:
																	"Please answer the question above",
															})}
														/>
														{errors &&
															errors.amounnt_capital &&
															errors
																.amounnt_capital
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.amounnt_capital
																			.message
																	}
																</span>
															)}
													</Grid>
													<Grid item xs={12}>
														<TextField
															id="finance_balance"
															name="finance_balance"
															variant="filled"
															label="How do you plan to finance the balance?"
															multiline
															fullWidth
															rows={3}
															inputRef={register({
																required:
																	"Please answer the question above",
															})}
														/>
														{errors &&
															errors.finance_balance &&
															errors
																.finance_balance
																.message && (
																<span
																	className={
																		styles.redText
																	}
																>
																	{
																		errors
																			.finance_balance
																			.message
																	}
																</span>
															)}
													</Grid>
													<Grid item xs={12}>
														<TextField
															id="other_info"
															name="other_info"
															inputRef={register}
															variant="filled"
															label="Any other information you want to provide"
															multiline
															fullWidth
															rows={3}
														/>
													</Grid>
													<Grid item xs={12}>
														<FormControlLabel
															id="minimum_liquid"
															name="minimum_liquid"
															control={
																<Checkbox />
															}
															label="Minimum liquid capital investment is $500k. Do You Meet This Requirement?"
															sx={{
																"& .MuiSvgIcon-root":
																	{
																		fontSize: 28,
																	},
															}}
															inputRef={register({
																required:
																	"Please answer the question above",
															})}
														/>
														{errors &&
															errors.minimum_liquid &&
															errors
																.minimum_liquid
																.message && (
																<>
																	<br />
																	<span
																		className={
																			styles.redText
																		}
																	>
																		{
																			errors
																				.minimum_liquid
																				.message
																		}
																	</span>
																</>
															)}
													</Grid>
													<Grid item xs={12}>
														<p>
															TERMS AND CONDITIONS
														</p>
														<span>
															This is not an offer
															of a franchise.
															Offers only will be
															made through our
															Uniform Franchise
															Offering Circular
															"FRANCHISE
															DISCLOSURE
															DOCUMENT". In states
															with laws which
															require franchises
															to be registered, an
															offer will not be
															made unless or until
															the franchise is
															registered. Those
															states include CA,
															HI, WA, ND, SD, MN,
															WI, IL, IN, MI, RI,
															NY, MD and VA.
														</span>
														<br />
														<br />
														<Switch
															id="terms_conditions"
															name="terms_conditions"
															onChange={
																handleChecked
															}
															inputRef={register({
																required:
																	"Please read and accept the terms and conditions",
															})}
														/>

														<span
															variant="button"
															fontWeight="regular"
															color="text"
															ml={-1}
															sx={{
																cursor: "pointer",
																userSelect:
																	"none",
															}}
															onClick={
																handleChecked
															}
														>
															&nbsp;&nbsp;I have
															read and accept the
															terms and
															conditions.&nbsp;
														</span>
														{errors &&
															errors.terms_conditions &&
															errors
																.terms_conditions
																.message && (
																<>
																	<br />
																	<span
																		className={
																			styles.redText
																		}
																	>
																		{
																			errors
																				.terms_conditions
																				.message
																		}
																	</span>
																</>
															)}
													</Grid>
												</Grid>

												<Grid
													container
													item
													justifyContent="center"
													xs={12}
													my={2}
												>
													<Button
														type="submit"
														name="submit"
														variant="contained"
													>
														Send FORM
													</Button>
												</Grid>
											</Box>
										</form>
									</Grid>
								</div>
							</div>
						</section>
					</article>
				</Container>
			</div>
		</div>
	);
};

const testpage = () => {
	return <>this is a test.....</>;
};

export default RequestinformationPage;
// export default testpage;
